import { isNonEmptyString, isNonEmptyArray } from '../../../utils/checks'
import { SearchState } from '@/domain/search/types'
import { shouldShowPriceTooltip } from '@/domain/useCases/insurance/shouldShowPriceTooltip'

export const shouldDisplayCashPayRate = ({
  currentRefinements,
  price_label
}: {
  currentRefinements: SearchState['refinementList']
  price_label: string
  price: string[]
}): boolean => {
  if (!shouldShowPriceTooltip(price_label)) {
    return false
  }
  if (
    isNonEmptyArray(currentRefinements?.accepted_insurance) ||
    isNonEmptyString(currentRefinements?.accepted_insurance)
  ) {
    return false
  }

  return true
}
